'use client'

import '@/views/digital-banking/digital-banking.css'
import '@/sections/sections.css'

import { useState } from 'react'

function GetStarted({ data }) {
  const [selectedButton, setSelectedButton] = useState(0)
  const [videoLink, setVideoLink] = useState(data?.getStarted?.[0]?.videoLink || '')

  const getVideoTitle = () => {
    if (selectedButton === 0) {
      return 'alrajhi bank Malaysia tutorial video: How to open a DuitPlus Savings Account-i on the MY alrajhi app.'
    }

    return 'alrajhi bank Malaysia tutorial video: Enabling international and online transactions via the MY alrajhi app.'
  }

  return (
    <div className="get-started">
      <div className="inward-container container">
        <div data-aos="fade-up" data-aos-delay="150">
          <h2 className="heading mb-5">Get started with the app</h2>
        </div>
        <div className="toggle-slider-container">
          <div
            className="toggle-slider"
            style={{
              transform: `translateX(${selectedButton === 0 ? '0%' : '100%'})`
            }}
          />
          {data?.getStarted.map((item, index) => (
            <div
              key={item.title}
              className={`sliding-button ${selectedButton === index ? 'selected' : ''}`}
              onClick={() => {
                setSelectedButton(index)
                setVideoLink(item?.videoLink)
              }}
            >
              {item?.title}
            </div>
          ))}
        </div>
        <iframe
          data-aos="fade-up"
          data-aos-delay="150"
          className="video-player"
          src={videoLink}
          title={getVideoTitle()}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>

        {selectedButton === 0 ? (
          <ul className="listing ms-lg-5">
            <li>Download the MY alrajhi app from the App Store or Google Play.</li>
            <li>Follow the on-screen instructions to verify your identity using e-KYC.</li>
            <li>Fill in your personal details and set up your secure login credentials.</li>
            <li>Start banking instantly—no branch visit required.​</li>
          </ul>
        ) : (
          <ul className="listing ms-lg-5">
            <li>Log in to your MY alrajhi app and tap on 'Settings & Services'.</li>
            <li>From the settings selection, tap on 'Account & Card' and select 'Preferences'.</li>
            <li>Turn on 'Enable international payments' and save the changes.</li>
            <li>You have successfully enabled overseas transactions.</li>
          </ul>
        )}
      </div>
    </div>
  )
}

export default GetStarted
